import angular from 'angular';
import { MinimumWageReviewModalComponent } from './minimum-wage-review-modal.component';
import { WagePolicyHistoryModalComponent } from './wage-policy-history-modal.component';
import { WagePolicyListComponent } from './wage-policy-list.component';

export const WagePolicyModule = angular
    .module("apex.mainApp.wagePolicy", [])
    .component("apexWagePolicyList", WagePolicyListComponent)
    .component("apexMinimumWageReviewModal", MinimumWageReviewModalComponent)
    .component("apexWagePolicyHistoryModal", WagePolicyHistoryModalComponent)
    .name;
